/**
 * Zones d'intervention - Olney Tech Solutions
 * SEO local pour la métropole lilloise et les Hauts-de-France
 */

export const zones = [
  {
    slug: 'lille',
    name: 'Lille',
    region: 'Nord',
    population: '232 787',
    distance: '15 km',
    description: 'Capitale des Hauts-de-France, Lille est le coeur économique de la région. Nous accompagnons les entreprises lilloises dans leur transformation digitale.',
    keywords: ['agence web lille', 'création site internet lille', 'développeur web lille'],
    nearbyAreas: ['Roubaix', 'Tourcoing', 'Villeneuve-d\'Ascq', 'Marcq-en-Baroeul']
  },
  {
    slug: 'roncq',
    name: 'Roncq',
    region: 'Nord',
    population: '13 500',
    distance: '0 km',
    description: 'Basés à Roncq, nous connaissons parfaitement le tissu économique local. Intervention rapide pour les entreprises et particuliers de Roncq.',
    keywords: ['dépannage informatique roncq', 'création site web roncq', 'informaticien roncq'],
    nearbyAreas: ['Halluin', 'Neuville-en-Ferrain', 'Tourcoing', 'Bondues']
  },
  {
    slug: 'phalempin',
    name: 'Phalempin',
    region: 'Nord',
    population: '4 800',
    distance: '25 km',
    description: 'Nous intervenons régulièrement à Phalempin et ses environs pour la création de sites web et le dépannage informatique.',
    keywords: ['site internet phalempin', 'informaticien phalempin', 'web phalempin'],
    nearbyAreas: ['Seclin', 'Carvin', 'Libercourt', 'Attiches']
  },
  {
    slug: 'seclin',
    name: 'Seclin',
    region: 'Nord',
    population: '12 500',
    distance: '20 km',
    description: 'Zone industrielle dynamique, Seclin accueille de nombreuses PME que nous accompagnons dans leur digitalisation.',
    keywords: ['agence web seclin', 'site internet seclin', 'développeur seclin'],
    nearbyAreas: ['Lesquin', 'Templemars', 'Vendeville', 'Noyelles-lès-Seclin']
  },
  {
    slug: 'villeneuve-dascq',
    name: 'Villeneuve-d\'Ascq',
    region: 'Nord',
    population: '62 000',
    distance: '18 km',
    description: 'Technopole et ville universitaire, Villeneuve-d\'Ascq concentre startups et entreprises innovantes que nous accompagnons.',
    keywords: ['développeur web villeneuve d\'ascq', 'agence digitale villeneuve', 'site web villeneuve'],
    nearbyAreas: ['Lille', 'Marcq-en-Baroeul', 'Croix', 'Hem']
  },
  {
    slug: 'tourcoing',
    name: 'Tourcoing',
    region: 'Nord',
    population: '98 000',
    distance: '8 km',
    description: 'Troisième ville des Hauts-de-France, Tourcoing bénéficie de notre proximité pour des interventions rapides.',
    keywords: ['création site tourcoing', 'agence web tourcoing', 'développeur tourcoing'],
    nearbyAreas: ['Roubaix', 'Wattrelos', 'Mouvaux', 'Neuville-en-Ferrain']
  },
  {
    slug: 'roubaix',
    name: 'Roubaix',
    region: 'Nord',
    population: '98 800',
    distance: '12 km',
    description: 'Ville en pleine renaissance économique, Roubaix accueille de nombreux entrepreneurs que nous aidons à se digitaliser.',
    keywords: ['site web roubaix', 'agence digitale roubaix', 'création site roubaix'],
    nearbyAreas: ['Tourcoing', 'Wattrelos', 'Croix', 'Hem']
  },
  {
    slug: 'marcq-en-baroeul',
    name: 'Marcq-en-Baroeul',
    region: 'Nord',
    population: '40 000',
    distance: '10 km',
    description: 'Commune résidentielle et commerciale, Marcq-en-Baroeul héberge de nombreuses PME et professions libérales.',
    keywords: ['site internet marcq', 'développeur marcq-en-baroeul', 'agence web marcq'],
    nearbyAreas: ['Lille', 'La Madeleine', 'Bondues', 'Wasquehal']
  }
];

export const mainZones = ['lille', 'roncq', 'phalempin', 'seclin'];

export const getZoneBySlug = (slug) => zones.find(z => z.slug === slug);

export const getZonesSEOData = () => zones.map(zone => ({
  slug: zone.slug,
  title: `Agence Web à ${zone.name} | Création Site Internet | Olney Tech Solutions`,
  description: `Création de sites web et dépannage informatique à ${zone.name}. Agence web locale, intervention rapide. Sites vitrines, e-commerce, maintenance.`
}));
